import { createFileRoute, useParams, useNavigate } from '@tanstack/react-router'
import { useQuery, useMutation } from '@tanstack/react-query'
import { UpsertUserForm } from '@/src/components/manage/mutate/upsertUser'
import { Skeleton } from '@/src/components/ui/skeleton'
import AdminToolbar from '@/src/components/layout/AdminToolbar'
import { getUser, updateUser } from '@/src/api/user'

export const Route = createFileRoute('/_manage/manage/admin/users/$id')({
  component: EditUserPage,
})

function EditUserPage() {
  const navigate = useNavigate()
  const { id: userId } = useParams({ from: '/_manage/manage/admin/users/$id' })

  const { data: user, isLoading, error } = useQuery({
    queryKey: ['user', 'get', userId],
    queryFn: () => getUser({ data: { id: userId } }),
    enabled: !!userId,
  })

  const updateUserMutation = useMutation({
    mutationFn: (data: any) => updateUser({ data }),
    onSuccess: () => {
      navigate({ to: '/manage/admin/users' })
    },
  })

  if (!userId) {
    return <div className="p-8 text-red-500">No user ID provided.</div>
  }

  if (isLoading) {
    return (
      <div className="p-8">
        <Skeleton className="h-8 w-40 mb-4" />
        <Skeleton className="h-8 w-full mb-4" />
        <Skeleton className="h-8 w-full mb-4" />
        <Skeleton className="h-8 w-full mb-4" />
      </div>
    )
  }

  if (error || !user) {
    return <div className="p-8 text-red-500">Failed to load user.</div>
  }

  return (
    <div>
      <AdminToolbar>
        <AdminToolbar.Left>
          <AdminToolbar.Title>Edit User</AdminToolbar.Title>
        </AdminToolbar.Left>
      </AdminToolbar>
      <UpsertUserForm
        id={user.id}
        user={{
          id: user.id,
          name: user.name ?? undefined,
          email: user.email ?? undefined,
          role: (user as any).role?.role ?? undefined,
          organization: (user as any).organization?.name ?? undefined,
        }}
        isLoading={updateUserMutation.isPending}
        error={updateUserMutation.error?.message}
        callbackUrl="/manage/admin/users"
      />
    </div>
  )
}
